import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import StyledCard from 'components/styled-card';
import { NightlyResponse } from 'types/hcp/pdfreport.type';

const PulseRate = ({ nightly }: { nightly: NightlyResponse }) => {
  const { t } = useTranslation();
  return (
    <StyledCard id="pr" title={t('summary.pr-label')}>
      <Row gutter={[16, 16]}>
        <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 10 }} xl={{ span: 12 }}>
          {nightly?.settings?.showMaxPR && (
            <Row gutter={[16, 16]}>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                {t('summary.max-pr')}
              </Col>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                {nightly?.variables?.HRMax} {t('bpm')}
              </Col>
            </Row>
          )}
          <Row gutter={[16, 16]}>
            <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
              {t('summary.mean-pr')}
            </Col>
            <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
              {nightly?.variables?.HRM} {t('bpm')}
            </Col>
          </Row>
          {nightly?.settings?.showMinPR && (
            <Row gutter={[16, 16]}>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                {t('summary.min-pr')}
              </Col>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                {nightly?.variables?.HRMin} {t('bpm')}
              </Col>
            </Row>
          )}
          {nightly?.settings?.showEctopicBeats && (
            <Row gutter={[16, 16]}>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                {t('summary.ectopic-beats')}
              </Col>
              <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                {t('per-beat', { value: nightly?.variables?.percEct })}
              </Col>
            </Row>
          )}
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 14 }} xl={{ span: 12 }}>
          <Row gutter={[16, 16]}>
            <Col xs={{ span: 12 }} md={{ span: 16 }} lg={{ span: 20 }} xl={{ span: 20 }}>
              {t('nightly.pr-100')} {t('bpm')}
            </Col>
            <Col xs={{ span: 12 }} md={{ span: 8 }} lg={{ span: 4 }} xl={{ span: 4 }}>
              {nightly?.variables?.HRT}%
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col xs={{ span: 12 }} md={{ span: 16 }} lg={{ span: 20 }} xl={{ span: 20 }}>
              {t('nightly.pr-40')} {t('bpm')}
            </Col>
            <Col xs={{ span: 12 }} md={{ span: 8 }} lg={{ span: 4 }} xl={{ span: 4 }}>
              {nightly?.variables?.HRB}%
            </Col>
          </Row>
        </Col>
      </Row>
    </StyledCard>
  );
};

export default PulseRate;
